const config = {
  // BASE_URL: 'http://localhost:5000'
  // BASE_URL: 'https://sutivan.agrandgrp.com'
  BASE_URL: 'https://sutivan.hu'
};

export default config;
